/**
 * Normaliza uma lista de rótulos (strings), adicionando sufixos personalizados a duplicatas.
 *
 * Por exemplo:
 * Entrada (tipoDeSufixo = 'number'): ['A', 'B', 'C', 'A', 'B']
 * Saída:                            ['A', 'B', 'C', 'A (1)', 'B (1)']
 *
 * Entrada (tipoDeSufixo = 'whitespace'): ['A', 'B', 'C', 'A', 'B']
 * Saída:                             ['A', 'B', 'C', 'A ', 'B ']
 *
 * @param {string} tipoDeSufixo - Tipo de sufixo: 'number' ou 'whitespace'.
 * @param  {...string} strings - Lista de strings que podem conter duplicatas.
 * @returns {string[]} - Lista de strings com duplicatas renomeadas com o sufixo informado por parâmetro.
 */
export function normalizarRotulosDuplicados(tipoDeSufixo = "numero", ...strings) {
  const contador = {};
  const resultado = [];

  strings.forEach((str) => {
    if (contador.hasOwnProperty(str)) {
      contador[str]++;

      if (tipoDeSufixo === "whitespace") {
        resultado.push(`${str}${" ".repeat(contador[str])}`);
      } else {
        resultado.push(`${str} (${contador[str]})`);
      }

    } else {
      contador[str] = 0;
      resultado.push(str);
    }
  });

  return resultado;
}